import { createContext, useContext } from 'react';

export interface ERPCoreContextValue {
  /** True once ERPCoreProvider has mounted and all managers are initialized. */
  initialized: boolean;
}

export const ERPCoreContext = createContext<ERPCoreContextValue | null>(null);

export function useERPCore(): ERPCoreContextValue {
  const ctx = useContext(ERPCoreContext);
  if (!ctx) throw new Error('useERPCore must be used within ERPCoreProvider');
  return ctx;
}
